const RESET_STORE = 'splitSegmentAudioModalScreen/RESET_STORE';
const SET_IS_SHOWING = 'splitSegmentAudioModalScreen/SET_IS_SHOWING';
const SET_IS_PLAYING = 'splitSegmentAudioModalScreen/SET_IS_PLAYING';
const SET_IS_PROCESSING = 'splitSegmentAudioModalScreen/SET_IS_PROCESSING';
const SET_IS_SHOWING_CLOSE_CONFIRMATION =
  'splitSegmentAudioModalScreen/SET_IS_SHOWING_CLOSE_CONFIRMATION';
const SET_LAST_SPLITTER_PLACEMENT_POSITION =
  'splitSegmentAudioModalScreen/SET_LAST_SPLITTER_PLACEMENT_POSITION';
const SET_AUDIO = 'splitSegmentAudioModalScreen/SET_AUDIO';
const SET_AUDIO_SPLITTER_DURATION_MS =
  'splitSegmentAudioModalScreen/SET_AUDIO_SPLITTER_DURATION_MS';
const SET_AUDIO_SPLITTER_SPLITS =
  'splitSegmentAudioModalScreen/SET_AUDIO_SPLITTER_SPLITS';
const ADD_AUDIO_SPLITTER_SPLIT =
  'splitSegmentAudioModalScreen/ADD_AUDIO_SPLITTER_SPLIT';
const REMOVE_AUDIO_SPLITTER_SPLIT =
  'splitSegmentAudioModalScreen/REMOVE_AUDIO_SPLITTER_SPLIT';
const SET_AUDIO_SPLITTER_SPLITTER =
  'splitSegmentAudioModalScreen/SET_AUDIO_SPLITTER_SPLITTER';
const SET_AUDIO_SPLITTER_ACTIVE_SPLIT_ID =
  'splitSegmentAudioModalScreen/SET_AUDIO_SPLITTER_ACTIVE_SPLIT_ID';
const SET_AUDIO_SPLITTER_IS_SHOWING_SPLIT_BUTTON =
  'splitSegmentAudioModalScreen/SET_AUDIO_SPLITTER_IS_SHOWING_SPLIT_BUTTON';

export default {
  RESET_STORE,
  SET_AUDIO,
  SET_IS_SHOWING,
  SET_IS_PLAYING,
  SET_IS_PROCESSING,
  SET_IS_SHOWING_CLOSE_CONFIRMATION,
  SET_LAST_SPLITTER_PLACEMENT_POSITION,
  SET_AUDIO_SPLITTER_DURATION_MS,
  SET_AUDIO_SPLITTER_SPLITS,
  ADD_AUDIO_SPLITTER_SPLIT,
  REMOVE_AUDIO_SPLITTER_SPLIT,
  SET_AUDIO_SPLITTER_SPLITTER,
  SET_AUDIO_SPLITTER_ACTIVE_SPLIT_ID,
  SET_AUDIO_SPLITTER_IS_SHOWING_SPLIT_BUTTON,
};
